import React, { useCallback, useEffect, useState } from 'react';

import { Icon } from '../../../../../../components/Icon';
import { api } from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/toast';
import { colors } from '../../../../../../styles/tokens';
import {
  Avatar,
  Container,
  CountBadge,
  Empty,
  Header,
  Item,
  ItemText,
  ItemTime,
  List,
  NotifyButton,
  Title,
  TitleRow,
} from './styles';

interface IAtRiskStudent {
  user_id: string;
  fullname: string;
  days_inactive: number;
}

const getInitials = (fullname: string): string => {
  const [first, second] = fullname.trim().split(' ');

  return `${first?.[0] || ''}${second?.[0] || ''}`.toUpperCase();
};

const AtRiskStudents: React.FC = () => {
  const [students, setStudents] = useState<IAtRiskStudent[]>([]);
  const [notifying, setNotifying] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const { addToast } = useToast();

  useEffect(() => {
    api
      .get('users/gym/at-risk')
      .then(response => setStudents(response.data))
      .catch(() => setStudents([]));
  }, []);

  const handleNotify = useCallback(() => {
    setNotifying(true);

    api
      .post('users/gym/at-risk/notify')
      .then(response => {
        addToast({
          type: 'success',
          title: 'Push enviado',
          description: `${response.data.notified_count} aluno(s) notificado(s).`,
        });
      })
      .catch(() => {
        addToast({
          type: 'error',
          title: 'Erro ao notificar',
          description: 'Tente novamente mais tarde.',
        });
      })
      .finally(() => setNotifying(false));
  }, [addToast]);

  return (
    <Container>
      <Header type="button" onClick={() => setExpanded(current => !current)}>
        <TitleRow>
          <Title>Alunos em risco</Title>
          <CountBadge empty={!students.length}>{students.length}</CountBadge>
        </TitleRow>
        <Icon
          name={expanded ? 'expand_less' : 'expand_more'}
          size={22}
          color={colors.onSurfaceVariant}
        />
      </Header>

      {expanded && (
        <>
          {!students.length && (
            <Empty>Nenhum aluno em risco no momento 🎉</Empty>
          )}

          {!!students.length && (
            <>
              <NotifyButton
                type="button"
                onClick={handleNotify}
                disabled={notifying}
              >
                {notifying ? 'Enviando...' : 'Notificar todos'}
              </NotifyButton>

              <List>
                {students.map(student => (
                  <Item key={student.user_id}>
                    <Avatar>{getInitials(student.fullname)}</Avatar>
                    <div>
                      <ItemText>{student.fullname}</ItemText>
                      <ItemTime>
                        {student.days_inactive} dias sem treinar
                      </ItemTime>
                    </div>
                  </Item>
                ))}
              </List>
            </>
          )}
        </>
      )}
    </Container>
  );
};

export { AtRiskStudents };
